import React, { useState, useEffect } from 'react';
import './QuoteRandomizer.css';

const QuoteRandomizer = () => {
    const [quote, setQuote] = useState('');

    const allQuotes = [
        "The greatest glory in living lies not in never falling, but in rising every time we fall. — Nelson Mandela",
        "The way to get started is to quit talking and begin doing. — Walt Disney",
        "Your time is limited, so don't waste it living someone else's life. — Steve Jobs",
        "Confine yourself to observing and you always miss the point of your own life. The object can be stated this way: Live the best life you can. Life is a game whose rules you learn if you leap into it and play it to the hilt. Otherwise, you are caught off balance, continually surprised by the shifting play. Non-players often whine and complain that luck always passes them by. They refuse to see that they can create some of their own luck. -Darwi Odrade (ChapterHouse Dune)",
        "Survival is the ability to swim in strange water. - Frank Herbert",
        "Violence is the last refuge of the incompetent. - Isaac Asimov",
        "To succeed, planning alone is insufficient. -Isaac Asimov",
        "Summer is only beautiful when you know winter is coming. -Golden Geisha (The Boys)",

    ];

    const selectRandomQuote = () => {
        const randomIndex = Math.floor(Math.random() * allQuotes.length);
        setQuote(allQuotes[randomIndex]);
    };

    // Select a random quote when component mounts
    useEffect(() => {
        selectRandomQuote();
    }, []);

    return (
        <div className="quote-container">
            <h1 className="quote-title">Inspirational Quotes</h1>
           <p className="quote-text">{quote}</p>
            <button onClick={selectRandomQuote} className="quote-button">
                New Quote
            </button>
        </div>
    );
};

export default QuoteRandomizer;